export default function Studio() {
	return <section id="studio">
		<h1>Studio</h1>
		<div className="contentsplit">
			<img src="/img/studio.jpg" alt="" />
			<div className="p">
				<div>
					<i className="bullet"></i> Professional lighting and studio desk with displays for sponsors, team logos, and other information of your choice.
				</div>
				<div>
					<i className="bullet"></i> In-house stream graphics, animations, and transitions.
				</div>
				<div>
					<i className="bullet"></i> Instant replays and spectator camera tracks.
				</div>
				<div>
					<i className="bullet"></i> <a href="#team">Casters</a> dressed to impress.
				</div>
				<div>
					<i className="bullet"></i> Streamed to our <a href="https://twitch.tv/l33tstudio" target="_blank" rel="noreferrer">Twitch channel</a>.
				</div>
			</div>
		</div>
	</section>
}
